@if (documentQueueItems.length) {
  <div>
    @for (item of documentQueueItems; track item) {
      <div class="errors">
        <div class="row">
          <div class="col-xs-10">
            <app-processing-item
              [reviewId]="item.id"
              [file]="item.processingJobPayload.documentFile"
              [steps]="getSteps(item)"
              [fileSuffix]="item.fileSuffix">
            </app-processing-item>
          </div>
        </div>
      </div>
    }
  </div>
}